import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const News = () => {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const q = query(collection(db, "news"), orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);
        const newsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setNewsList(newsData);
      } catch (error) {
        console.error("❌ خطأ أثناء تحميل الأخبار:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return (
    <section style={styles.section} id="news">
      <h2 style={styles.title}>📰 الأخبار والتحديثات</h2>

      {loading ? (
        <p style={styles.loading}>⏳ جاري تحميل الأخبار...</p>
      ) : newsList.length === 0 ? (
        <p style={styles.noData}>لا توجد أخبار حالياً.</p>
      ) : (
        <div style={styles.grid}>
          {newsList.map((item) => (
            <div key={item.id} style={styles.card}>
              <div style={styles.imageWrapper}>
                <img
                  src={item.image}
                  alt={item.title}
                  style={styles.image}
                  loading="lazy"
                />
              </div>
              <div style={styles.content}>
                <h3 style={styles.cardTitle}>{item.title}</h3>
                {item.createdAt?.seconds && (
                  <p style={styles.date}>
                    {new Date(item.createdAt.seconds * 1000).toLocaleDateString("ar-EG")}
                  </p>
                )}
                <button
                  style={styles.button}
                  onClick={() => navigate(`/news/${item.id}`)}
                >
                  اقرأ المزيد
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: "#f7f9fc",
    padding: "80px 20px",
    textAlign: "center",
    direction: "rtl",
    fontFamily: "Cairo, sans-serif",
  },
  title: {
    fontSize: "2.3rem",
    color: "#004aad",
    fontWeight: "700",
    marginBottom: "50px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "30px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "14px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
    overflow: "hidden",
    textAlign: "right",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  imageWrapper: {
    width: "100%",
    height: "200px",
    overflow: "hidden",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.4s ease",
  },
  content: {
    padding: "20px",
  },
  cardTitle: {
    color: "#004aad",
    fontSize: "1.3rem",
    fontWeight: "700",
    marginBottom: "8px",
  },
  date: {
    fontSize: "0.85rem",
    color: "#777",
    marginBottom: "10px",
  },
  button: {
    backgroundColor: "#004aad",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "0.9rem",
    transition: "background 0.3s ease, transform 0.2s ease",
  },
  loading: {
    color: "#004aad",
    fontWeight: "600",
  },
  noData: {
    color: "#666",
    fontSize: "1.1rem",
    marginTop: "30px",
  },
};

export default News;
